import React from 'react'
import PropTypes from 'prop-types'

import {
  InfoDisplay,
  Button,
  Notification
} from '../'

import {
  default as AddressDisplayEdit
} from './AddressDisplayEdit'

class CurrentAddresses extends React.Component {
  static propTypes = {
    identityAddresses: PropTypes.object,
    onActionSuccess: PropTypes.func
  }

  state = {
    addCellphoneNumber: false,
    addLandlinePhoneNumber: false,
    addEmailAddress: false,
    addPhysicalAddress: false,
    editCellphoneNumbers: false,
    editLandlinePhoneNumbers: false,
    editEmailAddresses: false,
    editPhysicalAddresses: false,
    saveEdited: false,
    addDuplicateErrorMessage: null,
    addDuplicateErrorAddressType: null, // will be set to either 'msisdn', 'email' or 'physical' depending on which address type a duplication error occurred
    saveInProgress: false
  }

  handleErrorOnAddressAddition = (error) => {
    if (error.hasOwnProperty('graphQLErrors') && error.graphQLErrors.length > 0 && error.graphQLErrors[0].message.includes('duplicated')) {
      // now get error message nested in error object
      let graphQlErrorMessage = error.graphQLErrors[0].message
      let errorMessageToDisplay = graphQlErrorMessage.substring(
        graphQlErrorMessage.indexOf('"') + 1,
        graphQlErrorMessage.lastIndexOf('"')
      )
      let state = { saveInProgress: false }
      if (error.graphQLErrors[0].message.includes('phone')) {
        state = { addDuplicateErrorAddressType: 'msisdn' }
      } else if (error.graphQLErrors[0].message.includes('email')) {
        state = { addDuplicateErrorAddressType: 'email' }
      } else if (error.graphQLErrors[0].message.includes('address')) {
        state = { addDuplicateErrorAddressType: 'physical' }
      }
      this.setState(prevState => {
        let nextState = null
        let { addCellphoneNumber, addEmailAddress, addPhysicalAddress } = prevState
        if (addCellphoneNumber) {
          nextState = Object.assign(state, { addCellphoneNumber: false, addDuplicateErrorMessage: errorMessageToDisplay })
        } else if (addEmailAddress) {
          nextState = Object.assign(state, { addEmailAddress: false, addDuplicateErrorMessage: errorMessageToDisplay })
        } else if (addPhysicalAddress) {
          nextState = Object.assign(state, { addPhysicalAddress: false, addDuplicateErrorMessage: errorMessageToDisplay })
        }
        return nextState
      })
    } else {
      this.setState(prevState => {
        let nextState = null
        let { addCellphoneNumber, addEmailAddress, addPhysicalAddress } = prevState
        if (addCellphoneNumber) {
          nextState = { addCellphoneNumber: false }
        } else if (addEmailAddress) {
          nextState = { addEmailAddress: false }
        } else if (addPhysicalAddress) {
          nextState = { addPhysicalAddress: false }
        }
        return nextState
      })
    }
  }

  render() {
    let activeCellphoneNumbers = this.props.identityAddresses.edges.filter(({ node: address }) => (
      address.addressType === 'MSISDN' && !address.inactive
    ))
    let activeLandlinePhoneNumbers = this.props.identityAddresses.edges.filter(({ node: address }) => (
      address.addressType === 'LANDLINE' && !address.inactive
    ))
    let activeEmailAddresses = this.props.identityAddresses.edges.filter(({ node: address }) => (
      address.addressType === 'EMAIL' && !address.inactive
    ))
    let activePhysicalAddresses = this.props.identityAddresses.edges.filter(({ node: address }) => (
      address.addressType === 'PHYSICAL' && !address.inactive
    ))

    return (
      <div className='slds-m-top_medium'>
        <DuplicateNotification
          errorMessage={this.state.addDuplicateErrorMessage}
          errorAddressType={this.state.addDuplicateErrorAddressType}
          addressType='msisdn'
          onClick={() => this.setState({ addDuplicateErrorMessage: null, addDuplicateErrorAddressType: null })}
        />
        <InfoDisplay
          subtitle='Cellphone numbers'
          rows={
            <AddressDisplayEdit
              addresses={activeCellphoneNumbers}
              addressType='msisdn'
              identity={this.props.identityId}
              identityFirstName={this.props.identityFirstName}
              add={this.state.addCellphoneNumber}
              onAddCancel={() => this.setState({ addCellphoneNumber: false })}
              onAddSuccess={() => (
                this.setState(
                  {
                    addCellphoneNumber: false,
                    saveInProgress: false
                  },
                  () => this.props.onActionSuccess('Added')
                )
              )}
              onAddFail={this.handleErrorOnAddressAddition}
              edit={this.state.editCellphoneNumbers}
              saveEdited={this.state.saveEdited}
              onEditSuccess={(showArchived) => {
                if (showArchived) {
                  this.setState(
                    {
                      editCellphoneNumbers: false,
                      saveEdited: false,
                      saveInProgress: false
                    },
                    () => this.props.onActionSuccess('Archived')
                  )
                } else {
                  this.setState(
                    {
                      editCellphoneNumbers: false,
                      saveEdited: false,
                      saveInProgress: false
                    },
                    this.props.onActionSuccess
                  )
                }
              }}
              onEditFail={() => this.setState({
                editCellphoneNumbers: false,
                saveEdited: false,
                saveInProgress: false
              })}
              key='addressDisplayEdit_msisdn'
            />
          }
          edit={this.state.editCellphoneNumbers}
          actionButtons={this.state.editCellphoneNumbers
            ? null
            : [
                <Button
                  onClick={() =>this.setState({ addCellphoneNumber: true })}
                  disabled={this.state.addCellphoneNumber}
                  key='cellphoneNumbers_add'>
                  Add
                </Button>
              ]
          }
          onCancelClick={() => this.setState({ editCellphoneNumbers: false })}
          onSaveClick={() => this.setState({ saveEdited: true, saveInProgress: true })}
          onEditClick={() => this.setState({
            editCellphoneNumbers: true,
            editLandlinePhoneNumbers: false,
            editEmailAddresses: false,
            editPhysicalAddresses: false,
          })}
          editDisabled={this.state.addCellphoneNumber || activeCellphoneNumbers.length === 0}
          noFixedLayout={true}
          saveDisabled={this.state.saveInProgress}
          saveButtonLabel={this.state.saveInProgress ? 'Saving' : null}
          className='slds-m-bottom_large'
        />
        <DuplicateNotification
          errorMessage={this.state.addDuplicateErrorMessage}
          errorAddressType={this.state.addDuplicateErrorAddressType}
          addressType='landline'
          onClick={() => this.setState({ addDuplicateErrorMessage: null, addDuplicateErrorAddressType: null })}
        />
        <InfoDisplay
          subtitle='Landline phone numbers'
          rows={
            <AddressDisplayEdit
              addresses={activeLandlinePhoneNumbers}
              addressType='landline'
              identity={this.props.identityId}
              identityFirstName={this.props.identityFirstName}
              add={this.state.addLandlinePhoneNumber}
              onAddCancel={() => this.setState({ addLandlinePhoneNumber: false })}
              onAddSuccess={() => (
                this.setState(
                  {
                    addLandlinePhoneNumber: false,
                    saveInProgress: false
                  },
                  () => this.props.onActionSuccess('Added')
                )
              )}
              onAddFail={this.handleErrorOnAddressAddition}
              edit={this.state.editLandlinePhoneNumbers}
              saveEdited={this.state.saveEdited}
              onEditSuccess={(showArchived) => {
                if (showArchived) {
                  this.setState(
                    {
                      editLandlinePhoneNumbers: false,
                      saveEdited: false,
                      saveInProgress: false
                    },
                    () => this.props.onActionSuccess('Archived')
                  )
                } else {
                  this.setState(
                    {
                      editLandlinePhoneNumbers: false,
                      saveEdited: false,
                      saveInProgress: false
                    },
                    this.props.onActionSuccess
                  )
                }
              }}
              onEditFail={() => this.setState({
                editLandlinePhoneNumbers: false,
                saveEdited: false,
                saveInProgress: false,
              })}
              key='addressDisplayEdit_landline'
            />
          }
          edit={this.state.editLandlinePhoneNumbers}
          actionButtons={this.state.editLandlinePhoneNumbers
            ? null
            : [
                <Button
                  onClick={() => this.setState({ addLandlinePhoneNumber: true })}
                  disabled={this.state.addLandlinePhoneNumber}
                  key='landlinePhoneNumbers_add'>
                  Add
                </Button>
              ]
          }
          onCancelClick={() => this.setState({ editLandlinePhoneNumbers: false })}
          onSaveClick={() => this.setState({ saveEdited: true, saveInProgress: true })}
          onEditClick={() => this.setState({
            editLandlinePhoneNumbers: true,
            editCellphoneNumbers: false,
            editEmailAddresses: false,
            editPhysicalAddresses: false,
          })}
          editDisabled={this.state.addLandlinePhoneNumber || activeLandlinePhoneNumbers.length === 0}
          noFixedLayout={true}
          saveDisabled={this.state.saveInProgress}
          saveButtonLabel={this.state.saveInProgress ? 'Saving' : null}
          className='slds-m-bottom_large'
        />
        <DuplicateNotification
          errorMessage={this.state.addDuplicateErrorMessage}
          errorAddressType={this.state.addDuplicateErrorAddressType}
          addressType='email'
          onClick={() => this.setState({ addDuplicateErrorMessage: null, addDuplicateErrorAddressType: null })}
        />
        <InfoDisplay
          subtitle='Email addresses'
          rows={
            <AddressDisplayEdit
              addresses={activeEmailAddresses}
              addressType='email'
              identity={this.props.identityId}
              identityFirstName={this.props.identityFirstName}
              add={this.state.addEmailAddress}
              onAddCancel={() => this.setState({ addEmailAddress: false })}
              onAddSuccess={() => (
                this.setState(
                  {
                    addEmailAddress: false,
                    saveInProgress: false
                  },
                  () => this.props.onActionSuccess('Added')
                )
              )}
              onAddFail={this.handleErrorOnAddressAddition}
              edit={this.state.editEmailAddresses}
              saveEdited={this.state.saveEdited}
              onEditSuccess={(showArchived) => {
                if (showArchived) {
                  this.setState(
                    {
                      editEmailAddresses: false,
                      saveEdited: false,
                      saveInProgress: false
                    },
                    () => this.props.onActionSuccess('Archived')
                  )
                } else {
                  this.setState(
                    {
                      editEmailAddresses: false,
                      saveEdited: false,
                      saveInProgress: false
                    },
                    this.props.onActionSuccess
                  )
                }
              }}
              onEditFail={() => this.setState({
                editEmailAddresses: false,
                saveEdited: false,
                saveInProgress: false,
              })}
              showLoginButton={true}
              key='addressDisplayEdit_email'
            />
          }
          edit={this.state.editEmailAddresses}
          actionButtons={this.state.editEmailAddresses
            ? null
            : [
                <Button
                  onClick={() => this.setState({ addEmailAddress: true })}
                  disabled={this.state.addEmailAddress}
                  key='emailAdddresses_add'>
                  Add
                </Button>
              ]
          }
          onCancelClick={() => this.setState({ editEmailAddresses: false })}
          onSaveClick={() => this.setState({ saveEdited: true, saveInProgress: true })}
          onEditClick={() => this.setState({
            editEmailAddresses: true,
            editCellphoneNumbers: false,
            editLandlinePhoneNumbers: false,
            editPhysicalAddresses: false
          })}
          editDisabled={this.state.addEmailAddress || activeEmailAddresses.length === 0}
          noFixedLayout={true}
          saveDisabled={this.state.saveInProgress}
          saveButtonLabel={this.state.saveInProgress ? 'Saving' : null}
          className='slds-m-bottom_large'
        />
        <DuplicateNotification
          errorMessage={this.state.addDuplicateErrorMessage}
          errorAddressType={this.state.addDuplicateErrorAddressType}
          addressType='physical'
          onClick={() => this.setState({ addDuplicateErrorMessage: null, addDuplicateErrorAddressType: null })}
        />
        <InfoDisplay
          subtitle='Physical addresses'
          rows={
            <AddressDisplayEdit
              addresses={activePhysicalAddresses}
              addressType='physical'
              identity={this.props.identityId}
              identityFirstName={this.props.identityFirstName}
              add={this.state.addPhysicalAddress}
              onAddCancel={() => this.setState({ addPhysicalAddress: false })}
              onAddSuccess={() => (
                this.setState(
                  {
                    addPhysicalAddress: false,
                    saveInProgress: false
                  },
                  () => this.props.onActionSuccess('Added')
                )
              )}
              onAddFail={this.handleErrorOnAddressAddition}
              edit={this.state.editPhysicalAddresses}
              saveEdited={this.state.saveEdited}
              onEditSuccess={(showArchived) => {
                if (showArchived) {
                  this.setState(
                    {
                      editPhysicalAddresses: false,
                      saveEdited: false,
                      saveInProgress: false
                    },
                    () => this.props.onActionSuccess('Archived')
                  )
                } else {
                  this.setState(
                    {
                      editPhysicalAddresses: false,
                      saveEdited: false,
                      saveInProgress: false
                    },
                    this.props.onActionSuccess
                  )
                }
              }}
              onEditFail={() => this.setState({
                editPhysicalAddresses: false,
                saveEdited: false,
                saveInProgress: false,
              })}
              key='addressDisplayEdit_physical'
            />
          }
          edit={this.state.editPhysicalAddresses}
          actionButtons={this.state.editPhysicalAddresses
            ? null
            : [
                <Button
                  onClick={() => this.setState({ addPhysicalAddress: true })}
                  disabled={this.state.addPhysicalAddress}
                  key='physicalAddresses_add'>
                  Add
                </Button>
              ]
          }
          onCancelClick={() => this.setState({ editPhysicalAddresses: false })}
          onSaveClick={() => this.setState({ saveEdited: true, saveInProgress: true })}
          onEditClick={() => this.setState({
            editPhysicalAddresses: true,
            editCellphoneNumbers: false,
            editLandlinePhoneNumbers: false,
            editEmailAddresses: false
          })}
          editDisabled={this.state.addPhysicalAddress || activePhysicalAddresses.length === 0}
          noFixedLayout={true}
          saveDisabled={this.state.saveInProgress}
          saveButtonLabel={this.state.saveInProgress ? 'Saving' : null}
          className='slds-m-bottom_large'
        />
      </div>
    )
  }
}

const DuplicateNotification = ({ errorMessage, errorAddressType, addressType, onClick }) => {
  if (errorMessage && errorAddressType === addressType) {
    return (
      <Notification
        type='warning'
        message={errorMessage}
        onCloseClick={onClick}
        className='slds-m-bottom_small'
      />
    )
  } else {
    return null
  }
}

export default CurrentAddresses



// WEBPACK FOOTER //
// ./src/components/identity-contact-details/CurrentAddresses.js